import {
  buildApiClientHelpers,
  fetcher,
  buildConfig,
  type RequestInitWithJsonContent,
} from './build-api-client';

let token: string | undefined;
let trackingId: string | undefined;

export const octaneClient = buildApiClientHelpers(baseClient);

function baseClient<T>(
  endpoint: string,
  customConfig: RequestInitWithJsonContent = {},
): Promise<T> {
  const config = buildConfig(customConfig, token, trackingId);
  return fetcher<T>(process.env.NEXT_PUBLIC_OCTANE_URL, endpoint, config);
}

export function setJwtToken(jwtToken: string) {
  token = jwtToken;
}

export function clearJwtToken() {
  token = undefined;
}
